module.exports = __webpack_public_path__ + "img/083c792.png";